import { type Dispatch, type SetStateAction } from 'react'
import { toast } from 'sonner'

import { useCreateSalesLeadTag, useSalesLeadTags } from '@/models/salesLeadTag'
import { TagSelect } from './TagSelect'

interface LeadActionTagPickerProps {
  selectedIds: string[]
  onChange: Dispatch<SetStateAction<string[]>>
}

/** Picks the tags an Add tag run puts on each lead; typing a new name creates the tag. */
export function LeadActionTagPicker({ selectedIds, onChange }: LeadActionTagPickerProps) {
  const { data: allTags = [] } = useSalesLeadTags()
  const createTag = useCreateSalesLeadTag()

  function toggle(tagId: string) {
    onChange((ids) => (ids.includes(tagId) ? ids.filter((id) => id !== tagId) : [...ids, tagId]))
  }

  function create(name: string) {
    createTag.mutate(name, {
      onSuccess: (tag) => onChange((ids) => (ids.includes(tag.id) ? ids : [...ids, tag.id])),
      onError: () => toast.error('Failed to create tag'),
    })
  }

  return (
    <TagSelect
      tags={allTags}
      selectedIds={selectedIds}
      onToggle={toggle}
      onCreate={create}
      placeholder="Pick tags to add"
    />
  )
}
